import ButtonFixedPosition from 'app/ui/buttons/ButtonFixedPosition';

class Credits extends Phaser.Group {
  constructor({ game, closeBtnData }) {
    super(game);
    const sheet = 'ui';

    this.background = this.game.make.image(0, 0, 'bg_fade');
    this.background.anchor.set(0);
    this.add(this.background);
    this.background.inputEnabled = true;
    this.background.input.priorityID = 0;
    this.background.input.useHandCursor = false;

    this.panelContainer = this.game.make.group();
    this.add(this.panelContainer);

    this.panel = this.game.make.image(0, 0, sheet, 'credits');
    this.panel.anchor.set(0, 0.5);
    this.panelContainer.add(this.panel);

    this.createCloseButton(closeBtnData);
    this.positionElements();
  }

  createCloseButton(data) {
    if (data) {
      const { id, sfx_id, skin, ariaLabelID } = data;
      const opts = { game: this.game, id, x: 0, y: 0, sfx_id, skin, ariaLabelID };
      this.closeButton = new ButtonFixedPosition(opts);
      this.closeButton.onInputDown.add(this.handleClose, this);
      this.panelContainer.add(this.closeButton);
      const x = this.panel.width * 0.5;
      const y = this.panel.height * 0.5 + 60;
      this.closeButton.position.set(x, y);
    }
  }

  handleClose() {
    this.game.controller.closeCredits();
  }

  positionElements() {
    this.background.width = this.game.width;
    this.background.height = this.game.height;
    this.panelContainer.position.set((this.game.width - this.panelContainer.width) * 0.5, this.game.height * 0.48);
  }

  activate() {
    this.game.scale.onSizeChange.add(this.positionElements, this);
    const childIndex = this.game.stage.children.length;
    this.game.stage.addChildAt(this, childIndex);
  }

  deactivate() {
    this.game.scale.onSizeChange.remove(this.positionElements, this);
    this.game.world.remove(this);
  }

  destroy() {
    this.panelContainer.destroy(true);
    this.panelContainer = null;
    this.panel = null;
    this.closeButton.destroy(true);
    this.closeButton = null;
    this.background = null;
    this.deactivate();
    super.destroy(true);
  }
}

export default Credits;
